import { Types } from "./types";

type TypesConstraint = {
  [key in keyof Types]: key;
};

export type AcceptsKey = keyof TypesConstraint;

class AcceptsConstraint implements TypesConstraint {
  public Void = "Void" as const;

  // String of variable length
  public String = "String" as const;
  public StringList = "StringList" as const;

  public AccessCode = "AccessCode" as const;

  public Date = "Date" as const;
  public DateList = "DateList" as const;

  // String of variable length
  public Color = "Color" as const;
  public ColorList = "ColorList" as const;

  public Font = "Font" as const;

  public Document = "Document" as const;

  // String of variable length
  public FormInput = "FormInput" as const;
  public FormInputList = "FormInputList" as const;

  public KeyValueMap = "KeyValueMap" as const;

  // String of variable length
  public Text = "Text" as const;
  public TextList = "TextList" as const;

  public Branch = "Branch" as const;

  public MarkdownText = "MarkdownText" as const;

  public LeaderboardType = "LeaderboardType" as const;

  public Hints = "Hints" as const;

  // String of variable length
  public Image = "Image" as const;
  public ImageList = "ImageList" as const;

  public ImageFilter = "ImageFilter" as const;

  public ObjectAlignment = "ObjectAlignment" as const;

  // String of variable length
  public Video = "Video" as const;
  public VideoList = "VideoList" as const;

  // String of variable length
  public Audio = "Audio" as const;
  public AudioList = "AudioList" as const;

  // String of variable length
  public File = "File" as const;
  public FileList = "FileList" as const;

  // String of variable length
  public ConvertedFile = "ConvertedFile" as const;
  public ConvertedFileList = "ConvertedFileList" as const;

  public Subtitles = "Subtitles" as const;

  // HTTP(S) URI
  public Url = "Url" as const;
  public UrlList = "UrlList" as const;

  // Number (can be float or int)
  public Number = "Number" as const;
  public NumberList = "NumberList" as const;

  public Boolean = "Boolean" as const;
  public BooleanList = "BooleanList" as const;

  public OptInType = "OptInType" as const;

  // Scale
  public Scale = "Scale" as const;
  public ScaleList = "ScaleList" as const;

  public TimeRange = "TimeRange" as const;

  public Poll = "Poll" as const;
  public PollList = "PollList" as const;

  public PollType = "PollType" as const;

  public ChoiceOption = "ChoiceOption" as const;
  public ChoiceOptionList = "ChoiceOptionList" as const;

  public SwipeCard = "SwipeCard" as const;
  public SwipeCardList = "SwipeCardList" as const;

  public ChoiceMode = "ChoiceMode" as const;

  public ChoiceOptionLayout = "ChoiceOptionLayout" as const;

  public IdAndLabel = "IdAndLabel" as const;
  public IdAndLabelList = "IdAndLabelList" as const;

  public ThisOrThatPair = "ThisOrThatPair" as const;
  public ThisOrThatPairList = "ThisOrThatPairList" as const;

  public PollResult = "PollResult" as const;
  public PollResultList = "PollResultList" as const;

  // Geo location by lat/long
  public GeoLocation = "GeoLocation" as const;
  public GeoLocationList = "GeoLocationList" as const;

  // Geo bounds by lat/long
  public GeoBounds = "GeoBounds" as const;
  public GeoBoundsList = "GeoBoundsList" as const;

  public GeoCamera = "GeoCamera" as const;
  public GeoCameraList = "GeoCameraList" as const;

  // Geo bounds by lat/long
  public GeoMarker = "GeoMarker" as const;
  public GeoMarkerList = "GeoMarkerList" as const;

  public RasterTileSet = "RasterTileSet" as const;
  public RasterTileSetList = "RasterTileSetList" as const;

  // New XR Unity system
  public EulerAngles = "EulerAngles" as const;

  public XRTrackable = "XRTrackable" as const;
  public XRTrackableList = "XRTrackableList" as const;

  public XRRenderable = "XRRenderable" as const;
  public XRRenderableList = "XRRenderableList" as const;

  public XRVirtualHost = "XRVirtualHost" as const;

  public XRVirtualHostEffect = "XRVirtualHostEffect" as const;

  public XR360Renderable = "XR360Renderable" as const;
  public XR360RenderableList = "XR360RenderableList" as const;

  public Vec2 = "Vec2" as const;

  public ActionPoint = "ActionPoint" as const;
  public ActionPointList = "ActionPointList" as const;

  public ChartType = "ChartType" as const;

  public ChartVariable = "ChartVariable" as const;
  public ChartVariableList = "ChartVariableList" as const;

  public ChartCutoff = "ChartCutoff" as const;

  public XRHotspot = "XRHotspot" as const;
  public XRHotspotList = "XRHotspotList" as const;

  // AR/VR Marker
  public ARVRMarker = "ARVRMarker" as const;
  public ARVRMarkerList = "ARVRMarkerList" as const;

  public ARVRImage = "ARVRImage" as const;
  public ARVRImageList = "ARVRImageList" as const;

  public ARVR3DObject = "ARVR3DObject" as const;
  public ARVR3DObjectList = "ARVR3DObjectList" as const;

  public ARVRMaterial = "ARVRMaterial" as const;
  public ARVRMaterialList = "ARVRMaterialList" as const;

  public ARVRLight = "ARVRLight" as const;
  public ARVRLightList = "ARVRLightList" as const;

  public ARVRSphericalImage = "ARVRSphericalImage" as const;
  public ARVRSphericalImageList = "ARVRSphericalImageList" as const;

  public ARVRHitQuad = "ARVRHitQuad" as const;

  public MarkdownString = "MarkdownString" as const;

  public ImageUrl = "ImageUrl" as const;
  public ImageUrlList = "ImageUrlList" as const;
  public GeoPoint = "GeoPoint" as const;
  public GeoPointList = "GeoPointList" as const;
  public ARVRHitQuadList = "ARVRHitQuadList" as const;

  public MatchPairType = "MatchPairType" as const;
  public MatchPairValue = "MatchPairValue" as const;
  public MatchPairValueList = "MatchPairValueList" as const;

  public TrueOrFalse = "TrueOrFalse" as const;
  public TrueOrFalseLayout = "TrueOrFalseLayout" as const;
  public RedirectBehaviour = "RedirectBehaviour" as const;

  public RelatedStory = "RelatedStory" as const;
  public RelatedStoryList = "RelatedStoryList" as const;

  public RedirectOption = "RedirectOption" as const;
  public RedirectOptionList = "RedirectOptionList" as const;

  public VariableAction = "VariableAction" as const;
  public VariableActionList = "VariableActionList" as const;

  public LogicBranchType = "LogicBranchType" as const;

  public LogicBranchScoringOption = "LogicBranchScoringOption" as const;
  public LogicBranchScoringOptionList = "LogicBranchScoringOptionList" as const;

  public LogicBranchLogicOption = "LogicBranchLogicOption" as const;
  public LogicBranchLogicOptionList = "LogicBranchLogicOptionList" as const;
}

export const Accepts = new AcceptsConstraint();
